import { css } from '@emotion/react'
import { typo } from '@mathflat/common/style'

const S = {
  wrap: css`
    position: relative;
  `,
  field: css`
    height: 40px;
    padding: 0 12px;
    border: 1px solid var(--Colors-Gray-400);
    border-radius: var(--Radius-100);
    background: var(--White);
    color: var(--Colors-Gray-900);
    ${typo.body02};
    &:disabled {
      color: var(--Colors-Gray-500);
    }
  `,
  popover: css`
    position: absolute;
    bottom: calc(100% + 4px);
    left: 0;
    z-index: 10;
    display: flex;
    gap: 4px;
    width: 305px;
    height: 250px;
    padding: 0 18px;
    border: 1px solid var(--Colors-Gray-300);
    border-radius: var(--Radius-300);
    background: var(--White);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    .column {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 40px 0;
      overflow-y: auto;
      scrollbar-width: none;
      mask-image: linear-gradient(
        to bottom,
        transparent,
        var(--White) 48px,
        var(--White) calc(100% - 48px),
        transparent
      );
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .item {
      flex-shrink: 0;
      height: 40px;
      border-radius: var(--Radius-100);
      color: var(--Colors-Gray-900);
      ${typo.body01};
      &.active {
        background: var(--Colors-Sky-400);
        color: var(--White);
        font-weight: 700;
      }
      &.disabled {
        color: var(--Colors-Gray-500);
        cursor: default;
      }
    }
  `,
}

export default S
